module.exports = __webpack_public_path__ + "static/media/70731.77162e34.JPG";